import { Component } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/core/base/base.component';
import { Utils } from 'src/app/core/utils/khuyana.utils';
import { CommonDoctorSpecialtyViewModel } from 'src/app/model/common/doctor-specialty.view';
import { CommonDoctorViewModel } from 'src/app/model/common/doctor.view';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';
import { DOCTOR } from '../doctor.constants';
import { DoctorSpecialtiesDialogService } from './doctor-specialties-dialog.service';

@Component({
  selector: 'ms-common-specialties-dialog',
  templateUrl: './doctor-specialties-dialog.component.html',
})
export class DoctorSpecialtiesDialogComponent extends BaseComponent {
  readonly screen = DOCTOR;
  doctor: CommonDoctorViewModel = {};
  specialties: SelectItem<KhuyanaSelectItemModel<string>>[] = [];
  specialtiesShowed: SelectItem[] = [];
  specialtyHelp?: SelectItem | null;
  doctorSpecialties: SelectItem[] = [];
  specialtyNotSelected = true;
  specialtiesToSave: KhuyanaSelectItemModel<string>[] = [];

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    protected service: DoctorSpecialtiesDialogService
  ) {
    super();
  }

  onInit = () => {
    this.doctor = this.config.data.doctor;
    this.service.readSpecialtiesStore().subscribe((specialties) => {
      this.specialties = specialties
        .filter((specialty) => specialty.status)
        .map((specialty) => ({
          label: specialty.name,
          value: {
            id: specialty.id,
            name: specialty.name,
          },
        }));
      this.addCurrentSpecialties(this.doctor.specialties);
    });
  };

  addCurrentSpecialties = (
    specialties: CommonDoctorSpecialtyViewModel[] = []
  ) => {
    specialties.forEach((specialty) => {
      const found = this.specialties.find(
        (f) => f.value.id === specialty.specialty
      )!;
      this.specialtiesToSave.push(found.value);
      this.specialtiesToSave.sort(this.sortSpecialties);
    });
  };

  showSuggestions = ($event: any) => {
    if ($event.query === '') {
      this.specialtiesShowed = this.specialties;
    } else {
      this.specialtiesShowed = this.specialties.filter(
        (specialty) =>
          Utils.normalizeText(specialty.label!).indexOf(
            Utils.normalizeText($event.query)
          ) > -1
      );
    }
    this.specialtiesShowed = this.specialtiesShowed.filter((specialty) => {
      return (
        this.specialtiesToSave.find(
          (toSave) => toSave.id === specialty.value.id
        ) == null
      );
    });
  };

  add = () => {
    this.specialtiesToSave.push(this.specialtyHelp!.value);
    this.specialtiesToSave.sort(this.sortSpecialties);
    this.specialtyHelp = null;
  };

  remove = (id?: string) =>
    (this.specialtiesToSave = this.specialtiesToSave.filter(
      (specialty) => specialty.id !== id
    ));

  save = () => {
    this.service.setLoadingState();
    this.subscriptions.push(
      this.config.data
        .save(
          this.doctor.id,
          this.specialtiesToSave.map((specialty) => specialty.id)
        )
        .subscribe((result: CommonDoctorViewModel) => this.ref.close(result))
    );
  };

  private sortSpecialties = (
    a: KhuyanaSelectItemModel<string>,
    b: KhuyanaSelectItemModel<string>
  ): number => {
    if (a.id! > b.id!) {
      return 1;
    }
    if (a.id! < b.id!) {
      return -1;
    }
    return 0;
  };
}
